import { create } from 'zustand';

/**
 * Cross-page selection state for metros.
 *
 * The actual list of metros now lives behind `useMetroData` (which fetches
 * from the API). This store is intentionally tiny — it only tracks which
 * metro the user has selected so the map and the rankings table can react
 * to selections from each other.
 *
 * 2026-07-03 (V2 feedback follow-up): added `isPopupExpanded` so the
 * Leaflet popup can request a promotion to a fullscreen modal on the
 * Map page. Kept here (rather than as MapExplorer-local useState) so
 * MetroPopup and MetroBubble can subscribe directly without prop
 * drilling through LeafletMap.
 */
interface MetroStore {
  readonly selectedMetroId: string | null;
  readonly isPopupExpanded: boolean;
  selectMetro: (id: string | null) => void;
  setPopupExpanded: (expanded: boolean) => void;
}

export const useMetroStore = create<MetroStore>((set) => ({
  selectedMetroId: null,
  isPopupExpanded: false,
  selectMetro: (id) =>
    set({
      selectedMetroId: id,
      // Deselecting the metro should also collapse the fullscreen
      // popup (if it was open). Re-selecting a different metro
      // starts fresh in popup mode.
      isPopupExpanded: id === null ? false : false,
    }),
  setPopupExpanded: (expanded) => set({ isPopupExpanded: expanded }),
}));
